import React from "react";
import "../CSS/Contact.css"

const Contact = () => {
  return ( 
    <>
    <h2>Contact me</h2>
    </>
   );
}
 
export default Contact;